import React from 'react'
import { Warning } from '@phosphor-icons/react'

export const LinkedInTestConfig: React.FC = () => {
  return (
    <div className="flex items-start gap-2 p-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg">
      <Warning className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
      <p className="text-xs text-amber-700 dark:text-amber-400">
        Testing this node creates a <strong>sales task</strong> in your task list. No direct LinkedIn API call is made.
      </p>
    </div>
  )
}
